import { Button, Modal, Space } from 'antd';
import { useTranslation } from 'react-i18next';

interface Props {
  errorPayload: string[];

  onClose: () => any;
}

export function HomeUploadFailedModal(props: Props) {
  const { onClose } = props;
  const { t } = useTranslation(undefined, {
    keyPrefix: 'homes.upload.failed',
  });

  const erors = props.errorPayload;

  return (
    <Modal
      title={t('title')}
      visible
      onCancel={onClose}
      footer={[
        <Button key="close" type="primary" onClick={onClose}>
          {t('close')}
        </Button>,
      ]}
    >
      <Space direction="vertical" size="large">
        {erors}
      </Space>
    </Modal>
  );
}
